import WarningIcon from '@mui/icons-material/Warning';
import {Chip} from '@mui/material';
import {styled} from '@mui/material/styles';

const BetaVersionChip = styled(Chip)(({theme}) => ({
  padding: theme.spacing(0.3, 0.6),
  height: 20,
  marginTop: 2,
  fontSize: '0.6rem',
  fontWeight: 600,
  color: '#fff',
  borderRadius: 999,
  backgroundColor: theme.palette.grey[400],
  '& .MuiChip-icon': {
    color: '#fff',
    marginLeft: theme.spacing(0.5)
  }
}));

export default () => <BetaVersionChip icon={<WarningIcon sx={{fontSize: 11}} />} label="Préversion" />;
